import { delegatePackageConstants } from "@constants";

const initalState = {
  edit: {
    processing: false
  },
  typeOptions: {
    loading: false,
    data: [],
    fail: null
  }
};

export const delegatePackage = (state = initalState, action) => {
  switch (action.type) {
    case delegatePackageConstants.EDIT_DELEGATE_PACKAGE_REQUEST:
      return {
        ...state,
        edit: {
          processing: true
        }
      };
    case delegatePackageConstants.EDIT_DELEGATE_PACKAGE_DONE:
      return {
        ...state,
        edit: {
          processing: false
        }
      };
    case delegatePackageConstants.GET_TYPE_OPTIONS_REQUEST:
      return {
        ...state,
        typeOptions: {
          loading: true,
          data: []
        }
      };
    case delegatePackageConstants.GET_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        typeOptions: {
          loading: false,
          data: action.typeOptions
        }
      };
    case delegatePackageConstants.GET_TYPE_OPTIONS_FAILURE:
      return {
        ...state,
        typeOptions: {
          loading: false,
          data: [],
          fail: action.error
        }
      };
    case delegatePackageConstants.RESET_TYPE_OPTIONS_SUCCESS:
      return {
        ...state,
        typeOptions: initalState.typeOptions
      };
    default:
      return state;
  }
};
